/**
 * VersionsSkeleton — N placeholder rows shaped like a VersionCard
 * header, used during the initial fetch so the page doesn't jump
 * when the real data arrives. Bars render through the shared Skeleton
 * primitive (fill + pulse); this file owns geometry only.
 */
import React from 'react';
import { Skeleton } from '../../../../components/ui/Skeleton';
import styles from './VersionsSkeleton.module.css';

interface VersionsSkeletonProps {
  rows?: number;
}

export default function VersionsSkeleton({
  rows = 4,
}: VersionsSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={styles.entry}>
          <Skeleton className={styles.node} />
          <div className={styles.card}>
            <Skeleton className={`${styles.bar} ${styles.barId}`} />
            <span className={styles.summaryStack}>
              <Skeleton className={`${styles.bar} ${styles.barLabel}`} />
              <Skeleton className={`${styles.bar} ${styles.barSummary}`} />
            </span>
            <Skeleton className={`${styles.bar} ${styles.barMeta}`} />
            <Skeleton className={`${styles.bar} ${styles.barChev}`} />
          </div>
        </div>
      ))}
    </>
  );
}
